// Ultra minimal - just static HTML, no hooks, no fetch
const HookFeed = ({ onBack }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#000',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui, sans-serif'
    }}>
      <div style={{ textAlign: 'center', padding: 20 }}>
        <div style={{ fontSize: 64, marginBottom: 20 }}>👁️</div>
        <h1 style={{ fontSize: 28, fontWeight: 'bold', marginBottom: 10 }}>HOOK</h1>
        <p style={{ opacity: 0.6, marginBottom: 30 }}>Coming soon - Reels for golfers</p>
        <button 
          onClick={() => onBack && onBack()}
          style={{
            padding: '14px 32px',
            backgroundColor: '#22c55e',
            border: 'none',
            borderRadius: 999,
            color: '#fff',
            fontSize: 16,
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default HookFeed;
